angular.module('bribac.components.moodQuestionModalComponent', [
    'bribac.translations'
])
    .component('moodQuestionModalComponent', {
        templateUrl: 'mood-question-modal.html',
        controller: 'MoodQuestionComponentCtrl',
        bindings: {
            close: '&',
            dismiss: '&',
            modalInstance: '<',
            resolve: "<"
        }
    })

    .controller('MoodQuestionComponentCtrl', function ($translate) {

        var $ctrl = this
        var selected, found = false;
        $ctrl.selected_questions;

        $ctrl.questions = [$translate.instant('components.moodQuestionComponent.question1'),
        $translate.instant('components.moodQuestionComponent.question2'),
        $translate.instant('components.moodQuestionComponent.question3'),
        $translate.instant('components.moodQuestionComponent.question4'),
        $translate.instant('components.moodQuestionComponent.custom')]

        $ctrl.$onInit = function () {
            if ($ctrl.resolve.selectedId) {
                selected = $ctrl.resolve.selectedId
                for (var i = 0; i <= $ctrl.questions.length - 1; i++) {
                    if ($translate.instant($ctrl.questions[i]) == selected) {
                        $ctrl.selected_questions = selected
                        found = true
                        break
                    }
                }
                if (!found) {
                    $ctrl.selected_questions = $ctrl.questions[$ctrl.questions.length-1]
                    $ctrl.form.customMoodQuestion = selected
                }
            } else {
                $ctrl.selected_questions = $ctrl.questions[0];
            }
        }

        $ctrl.updateSelection = function (selectedItem) {
            this.selected_questions = selectedItem
        }

        $ctrl.saveMoodQuestion = function () {
            if ($ctrl.form.$invalid) {
                return
            }

            if ($ctrl.selected_questions == $translate.instant('components.moodQuestionComponent.custom')) {
                $ctrl.resolve.callbacks.onSaveSuccess($ctrl.form.customMoodQuestion)
                $ctrl.form.customMoodQuestion = ""
            } else {
                $ctrl.resolve.callbacks.onSaveSuccess($translate.instant($ctrl.selected_questions))
            }
            $ctrl.selected_questions = ""
            $ctrl.close()
        }

        $ctrl.isCustomSelected = function(){
            return $ctrl.selected_questions == $translate.instant('components.moodQuestionComponent.custom')
        }

    });